<template>
	<v-card
			color="nyLightYellow"
			class="mb-3"

			to="/Chat"
	>
		<v-card-text>
			<div
					class="orange--text text--darken-2 TitleFont text-center mb-3 CardTitleSize"
			>
				Prenota l'incontro conoscitivo
			</div>
			<div class="poppins-regular text-center">
				Scrivi ora
				{{
				NutritionistProfile.Gender === 1
				? "al tuo "
				: "alla tua "
				}}
				nutritionista per prenotare
				<span class="font-weight-bold"
				>l'incontro gratuito</span
				>.
			</div>
			<v-divider class="my-2"></v-divider>
			<div class="mb-2">
				<v-icon
						small
						color="orange darken-2"
						class="mr-2"
				>fas fa-fw fa-seedling
				</v-icon>
				Una videochiamata di circa 20 minuti per
				condividere le tue esigenze e scoprire
				il percorso personalizzato proposto dal
				tuo nutrizionista
			</div>

			<div class="poppins-regular">
				<v-icon
						small
						color="orange darken-2"
						class="mr-2"
				>fas fa-fw fa-info-circle
				</v-icon
				>
				Se avrai un imprevisto potrai sempre
				spostare o annullare la videochiamata.
			</div>
		</v-card-text>
	</v-card>
</template>
<script>
export default {
	name: "BookIcStatic",
	props: {
		NutritionistProfile: {}
	}
}
</script>
